import React from 'react';
import { SampleCarousel } from './SampleCarousel';
export function SolutionSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-345">
      <div className="max-w-4xl mx-auto text-center" data-id="element-346">
        <h2 className="text-[20px] font-black mb-4 text-[#5B3FA0]" data-id="element-347">
          LA SOLUCIÓN: EFEMÉRIDES LISTAS SECUNDARIA
        </h2>

        <p className="text-xl md:text-2xl font-medium text-gray-700 mb-6 max-w-3xl mx-auto" data-id="element-348">
          Un recurso completo diseñado para que tengas actividades organizadas
          mes a mes durante todo el año.Simplemente buscás la fecha que
          necesitás y la propuesta ya está lista para trabajar.
        </p>

        <SampleCarousel data-id="element-349" />

        <p className="text-2xl font-black text-gray-900" data-id="element-350">
          <span className="px-2 text-[#2E9E8F] bg-[#FFFFFF]" data-id="element-351">
            Sin perder tiempo. Sin empezar desde cero. Sin improvisar.
          </span>
        </p>
      </div>
    </section>;
}